import loadComponents from './components/index'
import loadBlocks from './blocks'

const attrAccordion = 'data-accordion'
const attrAccordionHeader = 'data-accordion-header'
const attrAccordionContent = 'data-accordion-content'

export default (editor, opts = {}) => {
  const options = { ...{
    // Object to extend the default accordion block, eg. `{ label: 'Accordion', attributes: { ... } }`
    // Pass a falsy value to avoid adding the block
    accordionBlock: {},

    // Object to extend the default accordion properties
    accordionProps: {},

    // Object to extend the default accordion content properties
    accordionHeaderProps: {},

    // Object to extend the default accordion content properties
    accordionContentProps: {},

    // Accordion attribute identifier (main component)
    attrAccordion,

    // Accordion header attribute identifier
    attrAccordionHeader,

    // Accordion content attribute identifier
    attrAccordionContent,

    // Default class to use on accordion
    classAccordion: 'accordion',

    // Class used on accordion when active
    classAccordionActive: 'accordion--active',

    // Default class to use on accordion header
    classAccordionHeader: 'accordion-header',

    // Default class to use on accordion content
    classAccordionContent: 'accordion-content',

    // Default accordion template
    template: `
      <div ${attrAccordionHeader} class="accordion-header">
        <div>Accordion Header</div>
      </div>
      <div ${attrAccordionContent} class="accordion-content">
        <div>Accordion Content</div>
      </div>
    `,

    // Default template for new added accordion contents
    templateAccordionContent: `<div>Accordion Content</div>`
  }, ...opts 
}

  // Add components
  loadComponents(editor, options)

  // Add blocks
  loadBlocks(editor, options)
}
